import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

class SearchPromotion extends Component {
    render() {
        return (
            <div>
                {this.props.items.length ? (
                    <table className="display_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Title</th>
                                <th>Amount</th>
                                <th>Expires</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.items.map((item, i) =>
                                <tr className="clickable" key={i} onClick={() => this.props.history.push(this.props.location.pathname + '/' + item.id)}>
                                    <td className="record-number">{i + this.props.startPosition + 1}</td>
                                    <td data-id="Title">{item.title}</td>
                                    <td data-id="Amount"><NumberFormat value={item.value} displayType={'text'} placeholder="0.00" prefix={item.sale_type ? '$' : ''} suffix={!item.sale_type ? '%' : ''} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} /></td>
                                    <td data-id="Expires">{!!item.end ? item.end : 'N/A'}</td>
                                    <td className="edit-cell"><div className="edit_btn">Edit</div></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    <div>No Results</div>
                )}
            </div>
        )
    }
}

SearchPromotion.defaultProps = {
    items: [],
    startPosition: 0,
    clickHandle: null
}

export default SearchPromotion



// WEBPACK FOOTER //
// ./src/components/search/SearchPromotion.js